import { Link } from 'react-router-dom';
import { companyInfo } from '../data/siteData';

export default function GoldPurchaseBanner() {
  const specItems = [
    { label: "GAMLE GULD- & SØLVSMYKKER", detail: "Ring, kæder & vedhæng" },
    { label: "GULDKÆDER & ARMBÅND", detail: "8k, 14k, 18k, 21k, 22k, 24k" },
    { label: "SØLVTØJ & BESTIK", detail: "Tretårnet & 925s sølv" },
    { label: "GULD- & SØLVMØNTER", detail: "Jubilæum & samlinger" },
    { label: "ARVESTYKKER & TANDGULD", detail: "Mønter, boer & samlinger" },
    { label: "VURDERINGSPRIS", detail: "Gældende dagspris" },
  ];

  return (
    <section className="w-full bg-[#F9F8F6] my-12 sm:my-20">
      <div className="w-full px-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-[550px] border-y border-[#E2DDD3]">
          
          {/* Left Column: Image with Overlaid Typography */}
          <div className="relative min-h-[350px] lg:min-h-full bg-[#0B132B] overflow-hidden flex items-center justify-center p-8">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/807b5052-bea6-494e-8947-b0c29529a13c/img-2724-1-1024x682.jpg"
              alt="Guld og sølv opkøb"
              className="absolute inset-0 w-full h-full object-cover opacity-60"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-transparent to-black/30"></div>

            <div className="relative z-10 text-center space-y-3 p-6">
              <span className="text-xs uppercase tracking-[0.3em] text-[#B5A897] font-semibold">
                BRØNSHØJ URE & GULD
              </span>
              <h3 className="font-serif text-3xl sm:text-5xl uppercase tracking-[0.2em] text-white font-normal leading-tight">
                GULDKØB & VURDERING
              </h3>
              <p className="text-xs text-stone-300 tracking-widest max-w-sm mx-auto uppercase">
                Uforpligtende & fortrolig betjening i butikken
              </p>
            </div>
          </div>

          {/* Right Column: Spec Sheet Data Block */}
          <div className="bg-[#0B132B] p-8 sm:p-14 text-white flex flex-col justify-between space-y-8">
            <div className="space-y-6">
              <div className="flex justify-between items-end border-b border-white/10 pb-4">
                <div>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-medium block mb-1">
                    AFREGNING TIL
                  </span>
                  <h2 className="font-serif text-3xl sm:text-4xl text-white uppercase tracking-widest font-normal">
                    HØJESTE DAGSPRIS
                  </h2>
                </div>
                <div className="text-right hidden sm:block">
                  <span className="text-xs uppercase tracking-widest text-[#B5A897]">BRØNSHØJ</span>
                </div>
              </div>

              <p className="text-xs text-stone-300 leading-relaxed font-sans">
                Har du gammelt guld, arvestykker eller smykker, du ikke længere bruger? Hos Brønshøj Ure & Guld giver vi altid en uforpligtende og professionel vurdering til gældende dagspriser.
              </p>

              {/* Spec Rows */}
              <div className="space-y-1 pt-2">
                {specItems.map((spec, i) => (
                  <div key={i} className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-1 sm:gap-2 py-2.5 border-b border-white/10 text-[11px] sm:text-xs tracking-[0.1em] sm:tracking-[0.15em] uppercase">
                    <span className="text-stone-300 font-medium">{spec.label}</span>
                    <span className="text-[#B5A897]">{spec.detail}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 w-full">
              <Link
                to="/vi-koeber-guld-og-soelv"
                className="inline-block border border-white/40 text-white bg-transparent hover:bg-white hover:text-[#0B132B] transition-all text-[11px] sm:text-xs tracking-[0.15em] sm:tracking-[0.25em] uppercase px-5 sm:px-8 py-3.5 rounded-none font-medium text-center max-w-full"
              >
                FÅ VURDERET DIT GULD
              </Link>

              <a
                href={`tel:${companyInfo.phoneRaw}`}
                className="inline-block border border-[#B5A897] text-[#B5A897] bg-transparent hover:bg-[#B5A897] hover:text-[#0B132B] transition-all text-[11px] sm:text-xs tracking-[0.15em] sm:tracking-[0.25em] uppercase px-5 sm:px-8 py-3.5 rounded-none font-medium text-center max-w-full"
              >
                RING: {companyInfo.phone}
              </a>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
